export default "__VITE_ASSET__b96ba906__"